<template>
  <div class="checkout-view">
    <b-container>
      <section class="section section--loader" v-if="searching">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-else>
        <b-row>
          <b-col md="12">
            <div class="checkout-view__step">
              <div class="checkout-view__step-item">
                <vb-icon class="checkout-view__step-symbol" :name="'check'" :color="sass('light')" :size="16" />
                <router-link class="checkout-view__step-label" :to="{name: 'detail'}">Scelta camere</router-link>
              </div>
              <div class="checkout-view__step-item">
                <span class="checkout-view__step-symbol">2</span>
                <span class="checkout-view__step-label">Ultimo step</span>
              </div>
            </div>
          </b-col>
          <b-col md="12" xl="9" class="checkout-view__element checkout-view__element--first">
            <checkout-content-block :solution="selected_solution" />
          </b-col>
          <b-col md="12" xl="3" class="checkout-view__element checkout-view__element--second">
            <sidebar
              :validate_on_mount="validate_on_mount"
              :integration="integration"
              :availability="get_availability()"
              :live_price="live_price"
              :points="points"
              :loading="loading"
              :purchasing="purchasing"
              :completed="completed"
              :discount_codes="discount_codes"
              @purchase="sidebar_data => { book(sidebar_data) }"
              @commit="event => { this.$store.commit(event.name, event.payload) }"
            >
              <!--slot riepilogo ordine-->
              <template #resume>
                <resume
                  class="checkout-view__resume"
                  v-if="Object.keys(selected_solution.property).length"
                  :property_data="selected_solution.property"
                />
              </template>

              <!--slot messaggi di stato-->
              <template #message>
                <!--acquisto completato-->
                <div v-if="completed" class="vb-sidebar__block">
                  <div v-if="success" v-html="'Acquisto completato con successo'" />
                  <div v-else v-html="'C\'è stato un problema.'" />
                </div>
                <!--acquisto in corso-->
                <div v-if="!completed && purchasing" class="text-center">
                  <loader />
                </div>
              </template>

              <!--slot libero prima del pulsante di acquisto-->
              <template #before_purchase></template>
            </sidebar>
          </b-col>
        </b-row>
      </section>

      <loader-modal :show="!completed && purchasing" service="book" />
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { number, format } from 'mathjs'
import { service_handler } from '@src/services'
import { custom_event, get_config } from "@src/utilities"
import CheckoutContentBlock from '@liveeps/components/views/content-blocks/checkout'
import Resume from '@liveeps/components/blocks/resume/resume'

export default {
  name: 'checkout-view',

  components: {
    'checkout-content-block': CheckoutContentBlock,
    'resume': Resume,
  },

  props: {
  },

  data() {
    return {
      integration: this.$config.integration,
      loading: false,                         // caricamento dati
      purchasing: false,                      // sidebar completata -> acquisto in corso
      completed: false,                       // acquisto completato
      success: false,                         // esito della purchase() -> cambia il messaggio mostrato all'utente
      validate_on_mount: true,
      message: '',
      live_price: '0',
      points: 0,
    }
  },

  computed: {
    ...mapState({
      // stato globale
      searching: state => state.searching,
      discount_codes: state => state.discount_codes,

      // stato del modulo liveeps
      selected_solution: state => state.liveeps.selected_solution,
    }),

    ecommerce_data() {
      return {
        currency: "EUR",
        items: this.parseGa4EcommerceItems(this.selected_solution.property),
        value: format(number(this.selected_solution.property.rate.pricing.total), {notation: 'fixed', precision: 2}),
        live_price: this.selected_solution.property.live_price, // prezzo con markup per Rybbit
      }
    }
  },

  created() {
  },

  mounted() {
    this.live_price = this.selected_solution.property.live_price
    this.points = this.selected_solution.property.amount_points ? this.selected_solution.property.amount_points.points : this.points
    custom_event({ event: 'begin_checkout', ecommerce: this.ecommerce_data })
    custom_event({ event: 'add_to_cart', ecommerce: this.ecommerce_data })
  },

  methods: {

    // Chiamata alla book
    book(sidebar_data) {

      let book = {
        bookingData: {
          checkin: this.selected_solution.dates.checkin,
          checkout: this.selected_solution.dates.checkout,
          occupancy: this.selected_solution.dates.occupancy,
          payments: sidebar_data.payments,
          booker_email: sidebar_data.guest.payload.guestEmail,
          booker_telephone: sidebar_data.guest.payload.guestPhone,
          property_id: this.selected_solution.property.details.property_id,
          room_id: this.selected_solution.property.room.id,
          rate_id: this.selected_solution.property.rate.id,
          bed_group_id: this.selected_solution.property.bed_type.id,
          bed_group_token: this.selected_solution.property.bed_type.token,
          live_price: this.live_price,
          solution: this.selected_solution,
        },
        guestFirstName: sidebar_data.guest.payload.guestFirstName,
        guestLastName: sidebar_data.guest.payload.guestLastName,
        guestEmail: sidebar_data.guest.payload.guestEmail,
        guestEmailConf: sidebar_data.guest.payload.guestEmailConf,
        guestPhone: sidebar_data.guest.payload.guestPhone,
        guestPrivacy: sidebar_data.guest.payload.guestPrivacy,
        guestGdpr: sidebar_data.guest.payload.guestGdpr
      }

      if (sidebar_data.guest.payload.beneficiaryId) book.beneficiaryId = sidebar_data.guest.payload.beneficiaryId

      if (sidebar_data.booker.payload !== false) {
        book.guestAddress = sidebar_data.booker.payload.booker_address
        book.guestCity = sidebar_data.booker.payload.booker_city
      }

      if (sidebar_data.bill_to_pax.payload !== false) {
        book.guestAddress = sidebar_data.bill_to_pax.payload.guestAddress
        book.guestCity = sidebar_data.bill_to_pax.payload.guestCity
        book.guestPostalCode = sidebar_data.bill_to_pax.payload.guestPostalCode
        book.guestProvince = sidebar_data.bill_to_pax.payload.guestProvince
        book.guestFiscalCode = sidebar_data.bill_to_pax.payload.guestFiscalCode
      }
      
      this.purchasing = true
      this.success = false
      window.scrollTo(0,0)

      service_handler(
        'book',
        book,
        { track: 'checkout' },
      ).then(
        (success) => {
          this.success = true
          this.purchasing = false
          this.completed = true
          window.scrollTo(0,0) // la sidebar sparisce quasi per intero => riporto lo scroll della pagina in alto

          custom_event('confirmedCheckout', get_config('integration.company'), success.data.live_price, 'partnerBehaviour')
          if(success.data.boughtProductTypes){
            success.data.boughtProductTypes.forEach(productType => {
              custom_event('book', productType, success.data.live_price, 'productType')
            })
          }

          custom_event({
            event: 'purchase',
            ecommerce: { ...this.ecommerce_data, transaction_id: success.data.confirmcode }
          })
          
          // da valutare: a prenotazione completata cancello i dati necessari al checkout ( => per un'altra prenotazione bisogna ripassare per la ricerca)
          //this.$store.commit('liveeps/selected_solution', {})

          const resolved = this.$router.resolve({
            name: 'confirm',
            params: {
              confirm_code: success.data.confirmcode,
              itinerary_id: success.data.itinerary_id.toString()
            }
          })
          window.location.href = resolved.href
        },
        (error) => {
          this.log('[book] - error')
          this.log(error.response)
          this.validate_on_mount = true
          this.success = false
          this.purchasing = false
          custom_event('failedCheckout', get_config('integration.company'), book.bookingData.live_price, 'partnerBehaviour')
        }
      )
    },

    parseGa4EcommerceItems(property){
      return {
        item_id: property.room.id + "-" + property.rate.id,
        item_name: property.room.name + " - " + property.rate.id,
        price: format(number(property.rate.pricing.total), {notation: 'fixed', precision: 2})
      }
    },
  },
}
</script>

<style lang="scss" scoped>

  .checkout-view {

    &__element {

      &--first {
        order: 2;

        @include media-breakpoint-up(xl) {
          order: 1;
        }
      }

      &--second {
        order: 1;

        @include media-breakpoint-up(xl) {
          order: 2;
        }
      }
    }

    &__step {
      $this_step : &;
      background-color: $white;
      border-radius: 10px;
      padding: 15px 20px;
      display: flex;
      align-items: center;
      position: relative;
      margin-bottom: $grid-gutter-width*2;

      @include media-breakpoint-down(sm) {
        margin-bottom: 1rem;
      }

      &:before {
        content: '';
        position: absolute;
        top: 3px;
        left: 175px;
        right: 56%;
        bottom: 0;
        margin: auto;
        height: 1px;
        background-color: $gray-200;
        display: none;

        @include media-breakpoint-up(xl) {
          display: block;
        }
      }

      &-item {
        display: flex;
        align-items: center;
        flex-basis: 50%;

        @include media-breakpoint-up(sm) {
          flex-basis: 33%;
        }

        &:last-child {
          justify-content: center;
        }
      }

      &-symbol {
        background-color: var(--primary);
        border-radius: 50px;
        width: 25px;
        height: 25px;
        color: $white;
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-label {
        font-weight: $vb-font-weight-semibold;
        margin-left: 10px;

        @at-root #{$this_step}-item:first-child & {
          text-decoration: underline;

        }
      }
    }
  }


</style>